import { useState, useEffect } from 'react'

export const useFetchInfoSales = ({marvarApi, dispatch, onLogout, Forms, Helpers}) =>{
    const { FormRequestGlobal } = Forms
    const { formState, setFormState } = FormRequestGlobal

    const {convertToFloat} = Helpers

    // 2. Para mostrar animación de carga
    const [ loadingFetchInfoSales, setLoadingFetchInfoSales ] = useState(false)

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoSales = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/mgmt-sales/get-application-ID/${formState.idventa}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idventa > 0 ){
            setLoadingFetchInfoSales(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    
                    setFormState((prevState) => ({
                        ...prevState,
                        idvehiculo: data.idvehiculo || 0,
                        idcliente: data.idcliente || 0,
                        idcotizacion: data.idcotizacion || 0,
                        credito_fecha: data.credito_fecha || '',
                        fecha_venta: data.fecha_venta || '',
                        monto_venta: data.monto_venta || 0,
                        credito_dia_pago: data.credito_dia_pago || '',
                        aprobacion_check: data.aprobacion_check || '',
                        aprobacion_fecha: data.aprobacion_fecha || '',
                        clean_monto_venta: convertToFloat(data.monto_venta)
                        
                    }))
                    setLoadingFetchInfoSales(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoSales(false)
                })
        }
    }, [execute, formState.idventa])

    return { loadingFetchInfoSales, executeFetchInfoSales }
}

export const useFetchAllVehicleSales = ({marvarApi, dispatch, onLogout}) => {
    const [vehicleSales, setVehicleSales] = useState([])
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllVehicleSales = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/vehicle/mgmt-sales`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        fetchData()
            .then((resp) => {
                setVehicleSales(resp.data)
            })
            .catch(e => {
                console.log(e, '________ERROR')
            })
    }, [execute])

    return { vehicleSales, executeFetchAllVehicleSales }

}

export const useFetchInfoVehicle = ({marvarApi, dispatch, onLogout, Forms, Helpers}) =>{
    const { FormRequestGlobal: {formState, setFormState} } = Forms
    const { numberFormatter } = Helpers

    // 2. Para mostrar animación de carga
    const [ loadingFetchInfoVehicle, setLoadingFetchInfoVehicle ] = useState(false)

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoVehicle = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/get-info-vehicle/${formState.idvehiculo}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idvehiculo > 0 ){
            setLoadingFetchInfoVehicle(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp

                    setFormState((prevState) => ({
                        ...prevState,

                        tipo : data.tipo || '',
                        marca : data.marca || '',
                        modelo : data.modelo || '',
                        linea : data.linea || '',
                        matricula : data.matricula || '',
                        color : data.color || '',
                        motorCC : data.motorCC || '',
                        motorNo : data.motorNo || '',
                        chasis : data.chasis || '',
                        clean_costo_total: data.costo_total,
                        costo_total: numberFormatter.format(data.costo_total),
                        
                    }))

                    setLoadingFetchInfoVehicle(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoVehicle(false)
                })
        }
    }, [execute, formState.idvehiculo])

    return { loadingFetchInfoVehicle, executeFetchInfoVehicle }
}

export const useFetchInfoObservations = ({marvarApi, dispatch, onLogout, Forms}) => {

    const {FormRequestGlobal:{formState}} = Forms

    const [observations, setObservations] = useState([])
    const [loadingFetchObservations, setLoadingFetchObservations ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllObservations = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        if (formState.idventa > 0) {
            try {
                const response = await marvarApi.get(`/vehicle/mgmt-sales/log-vehicle/${formState.idventa}`)
                return response.data
            } catch (e) {
                console.log(e)
            }
        }else{
            setLoadingFetchObservations(true)
        }

    }

    useEffect(() => {
        setLoadingFetchObservations(true)
        if (formState.idventa > 0) {
            fetchData()
                .then((resp) => {
                    setObservations(resp)
                    setLoadingFetchObservations(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute, formState.idventa])

    return { observations, loadingFetchObservations, executeFetchAllObservations }

}

export const useFetchAllCustomers = ({marvarApi, dispatch, onLogout}) =>{

    // 1. Para almacenar los clientes
    const [customers, setCustomers] = useState([])


    // 2. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllCustomers = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/leases/common/get-customers`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    
                    setCustomers(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { customers, executeFetchAllCustomers }
}

export const useFetchAllVehicles = ({marvarApi, dispatch, onLogout, Forms}) =>{

    const {FormRequestGlobal:{formState}} = Forms

    // 1. Para almacenar los clientes
    const [vehicles, setVehicles] = useState([])


    // 2. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllVehicles = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/get-vehicles/${formState.idvehiculo}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setVehicles(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute, formState.idvehiculo])

    return { vehicles, executeFetchAllVehicles }
}

export const useFetchAllDeposits= ({marvarApi, dispatch, onLogout, Forms}) => {
    const [deposits, setDeposits] = useState([])
    const [loadingFetchDeposits, seteLoadingFetchDeposits ] = useState(false) //estado para animacion de carga
    
    const {FormRequestGlobal:{formState}} = Forms


    const [ execute, setExecute ] = useState(0)
    const executeFetchAllDeposits = async () => {
        setExecute(currentCount => currentCount + 1)

    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/vehicle/mgmt-sales/get-deposit/${formState.idventa}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idventa > 0 ){
            seteLoadingFetchDeposits(true)
            fetchData()
                .then((resp) => {
                    setDeposits(resp.data)
                    seteLoadingFetchDeposits(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    seteLoadingFetchDeposits(false)
                })
        }
    }, [execute])

    return { deposits, loadingFetchDeposits, executeFetchAllDeposits }

}

export const useFetchAllCashRegisters= ({marvarApi, dispatch, onLogout}) => {
    const [cashRegisters, setCashRegisters] = useState([])
    

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllCashRegisters = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/caja`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    const { data } = resp
                    setCashRegisters(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { cashRegisters, executeFetchAllCashRegisters }
}

export const useFetchAllBanks= ({marvarApi, dispatch, onLogout}) => {
    const [banks, setBanks] = useState([])
    

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllBanks = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/banco`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    const { data } = resp

                    setBanks(data)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { banks, executeFetchAllBanks }
}


export const useFetchAllFiles = ({marvarApi, dispatch, onLogout, Forms}) =>{
    const { FormRequestGlobal:{formState, setFormState} } = Forms

    // 1. Para mostrar animación de carga
    const [ loadingFetchInfoFiles, setLoadingFetchInfoFiles ] = useState(false)

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(0)
    const executeFetchAllFiles = async () => {
        setExecute(currentCount => currentCount + 1)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/mgmt-sales/get-documents/${formState.idventa}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    

    useEffect(() => {
        if(formState.idventa > 0 ){
            setLoadingFetchInfoFiles(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp

                    setFormState((prevState) => ({
                        ...prevState,
                        files: data
                    }))

                    setLoadingFetchInfoFiles(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoFiles(false)
                })
        }
    }, [execute, formState.idventa])

    return {loadingFetchInfoFiles, executeFetchAllFiles }
}

export const useFetchInfoDeposit = ({marvarApi, dispatch, onLogout, Forms}) =>{

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const { FormDeposit:{setFormState} } = Forms

    // 1. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({})

    // 2. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoDeposit = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/mgmt-sales/get-deposit-by-ID/${paramsToSearch.iddeposit}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.iddeposit > 0 ){
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        iddeposit: data.iddeposit || '',
                        idcaja : data.idcaja || '',
                        idbanco : data.idbanco || '',
                        boleta_numero : data.boleta_numero || '',
                        boleta_foto_path : data.boleta_foto_path || '',
                        boleta_foto_originalname : data.boleta_foto_originalname || '',
                        aprobacion_referencia_ach : data.aprobacion_referencia_ach || '',
                        aprobacion_observaciones : data.aprobacion_observaciones || '',
                        aprobacion_check : data.aprobacion_check || '',
                        deposito_fecha : data.deposito_fecha || '',
                        deposito_moneda : data.deposito_moneda || '',
                        deposito_observaciones : data.deposito_observaciones || '',
                        deposito_tipo_cambio : data.deposito_tipo_cambio || '',
                        movimiento_tipo : data.movimiento_tipo || '',
                        
                        deposito_monto : numberFormatter.format(data.deposito_monto) || '',
                        deposito_quetzales : numberFormatter.format(data.deposito_quetzal) || '',
                        deposito_dolares : numberFormatter.format(data.deposito_dolares) || '',
                        clean_deposito_monto : data.deposito_monto || '',
                        clean_deposito_quetzales : data.deposito_quetzal || '',
                        clean_deposito_dolares : data.deposito_dolares || '',
                    }))

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { setParamsToSearch, executeFetchInfoDeposit }
}

export const useFetchAllPreInventory = ({marvarApi, dispatch, onLogout, Forms}) =>{
    const { FormPreInvventory:{setFormState}, FormRequestGlobal:{formState}} = Forms

    // 1. Para mostrar animación de carga
    const [ loadingFetchPreInventory, setLoadingFetchPreInventory ] = useState(false)

    const [preInventory, setPreInventory] = useState([])

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(0)
    const executeFetchAllPreInventory = async () => {
        setExecute(currentCount => currentCount + 1)
    }

    
    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/mgmt-sales/get-preinventory/${formState.idventa}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idventa > 0 ){
            setLoadingFetchPreInventory(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    setPreInventory(resp.data)
                    setLoadingFetchPreInventory(false)

                })
                .catch(e => { 
                    console.log(e, '________ERROR')
                    setLoadingFetchPreInventory(false)
                })
        }
    }, [execute, formState.idventa])

    return {preInventory, loadingFetchPreInventory, executeFetchAllPreInventory }
}

export const useFetchInfoPreInventory = ({marvarApi, dispatch, onLogout, Forms}) =>{

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const { FormPreInvventory:{setFormState}, FormRequestGlobal:{formState} } = Forms

    const [paramsToSearch, setParamsToSearch] = useState({})

    // 2. Para mostrar animación de carga
    const [ loadingFetchPreInventory, setLoadingFetchPreInventory ] = useState(false)

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchPreInventory = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/mgmt-sales/get-preinventory-ID/${paramsToSearch.idvehicledeposit}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idvehicledeposit > 0){
            setLoadingFetchPreInventory(true)
            fetchData()
                .then((resp) => {

                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idvehicledeposit: data.idvehicledeposit || 0,
                        marca: data.marca || '',
                        modelo: data.modelo || '',
                        linea: data.linea || '',
                        color: data.color || '',
                        matricula: data.matricula || '',
                        chasis: data.chasis || '',
                        clean_valor: data.valor || '',
                        valor: numberFormatter.format(data.valor) || '',
                    }))
                    setLoadingFetchPreInventory(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchPreInventory(false)
                })
        }
    }, [execute])

    return { setParamsToSearch, loadingFetchPreInventory, executeFetchPreInventory }
}






